<div class="card">
  <div class="card-body">
    <h5 class="card-title">{{ title }}</h5>
    <ng-content></ng-content>
  </div>
</div>
